import { h } from 'preact';

/**
 * Apple-Calendar-style date tile for list rows: month abbreviation on top, day
 * number below. Used in the left icon slot of the convention and race lists
 * (GuiList elIconFunc) so rows without an image still get a strong visual
 * anchor.
 *
 * Colour rules mirror the old icon: today = success, cancelled = muted,
 * otherwise the accent (danger/orange) tone. A non-public convention shows a
 * small lock glyph in the corner, which is the signal the old lock icon gave.
 */
function monthAbbrev(date) {
    return date
        .toLocaleDateString('nb-NO', { month: 'short' })
        .replace(/\.$/, '')
        .toUpperCase();
}

function DateTile({ date, isPublic = true, isCancelled = false }) {
    if (!date) {
        return null;
    }
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) {
        return null;
    }
    const now = new Date();
    const isToday = d.toDateString() === now.toDateString();
    const otherYear = d.getFullYear() !== now.getFullYear();

    let monthClass = 'text-danger';
    if (isCancelled) {
        monthClass = 'text-body-tertiary';
    } else if (isToday) {
        monthClass = 'text-success';
    }
    const dayClass = isCancelled ? 'text-body-tertiary' : 'text-body';

    return (
        <div
            class='position-relative d-flex flex-column justify-content-center align-items-center rounded bg-body-secondary text-center ms-1'
            style='width: 52px; min-width: 52px; height: 52px; line-height: 1;'
        >
            <span class={`${monthClass} fw-bold`} style='font-size: 0.65rem; letter-spacing: 0.05em;'>
                {monthAbbrev(d)}
            </span>
            <span class={`${dayClass} fw-bold`} style='font-size: 1.35rem;'>
                {d.getDate()}
            </span>
            {otherYear && (
                <span class='text-body-secondary' style='font-size: 0.55rem;'>
                    {d.getFullYear()}
                </span>
            )}
            {!isPublic && (
                <i
                    class='fa-solid fa-lock text-danger position-absolute'
                    style='font-size: 0.6rem; top: 3px; right: 4px;'
                    title='Ikke offentlig'
                />
            )}
        </div>
    );
}

export default DateTile;
